import { StepDescription } from '../intefaces/step-description';
import { StepImpl } from './step-impl';

export class IntroductionStep extends StepImpl {
  constructor(
    text: string,
    name: string,
    public descriptions: StepDescription[]
  ) {
    super(text, name);
  }
}
